import { render, staticRenderFns } from "./AddStoneType.vue?vue&type=template&id=19926572&"
import script from "./AddStoneType.vue?vue&type=script&lang=js&"
export * from "./AddStoneType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports